/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_AvatarInputs */

const en_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

/**
* | output |
* | --- |
* | "Avatar" |
*
* @param {Settings_Profile_AvatarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profile_avatar = /** @type {((inputs?: Settings_Profile_AvatarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_AvatarInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profile_avatar(inputs)
});
export { settings_profile_avatar as "settings.profile.avatar" }